const INITIAL_STATE = [];

export default function complaintYears(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case 'data-load_FULFILLED': {
      if (payload && payload.key === 'complaintYears') {
        return [
          ...payload.response.data,
        ];
      }

      return state;
    }

    default:
      return state;
  }
}
